import { LegalClientActivity } from 'api/types/entity';
import { isYes, yesOrNotSelectValidation } from 'helpers';
import {
  TypedForm,
  FormErrors as FormErrorsBase,
  ObjectSchema,
  string,
  object,
  selectSchema,
} from 'libs/form';
import { Maybe } from 'types/maybe';
import { SelectType } from 'types/selectType';
import { YesOrNoSelectType } from 'types/yesOrNo';

export interface CompanyActivityFormType {
  activity: SelectType<LegalClientActivity>;
  otherActivity?: string;
  isLargeEnterprise: YesOrNoSelectType;
  isNominalHolder: YesOrNoSelectType;
  requiresNominalHoldingSubaccount: Maybe<YesOrNoSelectType>;
}

const isOtherActivity = (activity: SelectType<LegalClientActivity>) =>
  activity?.value === LegalClientActivity.Other;

export const getSchema = (): ObjectSchema<CompanyActivityFormType> =>
  object({
    activity: selectSchema(Object.values(LegalClientActivity))
      .default(null)
      .required(),

    otherActivity: string().when('activity', {
      is: isOtherActivity,
      then: (schema) => schema.required().max(200),
    }),
    isLargeEnterprise: yesOrNotSelectValidation.default(null).required(),
    isNominalHolder: yesOrNotSelectValidation.default(null).required(),
    requiresNominalHoldingSubaccount: yesOrNotSelectValidation
      .default(undefined)
      .nullable()
      .when('isNominalHolder', {
        is: isYes,
        then: (schema) => schema.default(null).required(),
      }),
  });

export const { Field, Form, useFormContext, Submit } =
  TypedForm<CompanyActivityFormType>();

export type FormErrors = FormErrorsBase<CompanyActivityFormType>;
